export var ALIGN_VALUES = ['justify', 'left', 'right'];
export var DEFAULT_LABELKEY = 'label';
export var SIZES = ['lg', 'sm'];